export default [
  {
    path: '/admin/project-managment',
    name: 'project-mgt-main',
    meta: { requiresAuth: true },
    component: () => import('@/pages/project-mgt/home')
  },
  {
    path: '/admin/site-profiles',
    name: 'site-profile',
    meta: { requiresAuth: true },
    component: () => import('@/pages/project-mgt/site-profile')
  },
  {
    path: '/admin/project-profiles',
    name: 'project-profile',
    meta: { requiresAuth: true },
    component: () => import('@/pages/project-mgt/project-profile')
  },
  {
    path: '/admin/project-profiles/:id',
    name: 'project-profile-view',
    component: () =>
      import('@/pages/project-mgt/project-profile/view-project.vue')
  },
  {
    path: '/admin/project-profiles/:project_id/milestone/:milestone_id',
    name: 'project-milestone-view',
    component: () => import('@/pages/project-mgt/milestone/index.vue')
  },
  {
    path: '/admin/tasks',
    name: 'task',
    component: () => import('@/pages/project-mgt/task')
  },
  {
    path: '/admin/tasks/create',
    name: 'task-create',
    component: () => import('@/pages/project-mgt/task/create.vue')
  },
  {
    path: '/admin/tasks/:id',
    name: 'task-edit',
    component: () => import('@/pages/project-mgt/task/edit.vue')
  },
  {
    path: '/admin/tasks/:id/views',
    name: 'task-view',
    component: () => import('@/pages/project-mgt/task/view.vue')
  },
  {
    path: '/admin/milestone-profiles',
    name: 'milestone',
    component: () => import('@/pages/project-mgt/milestone/table.vue')
  }
]
